module.exports = __webpack_public_path__ + "img/cylinder-button.5d1117b8.png";